<template>
  <div class="d-flex flex-column">
    <subnav :links="subnav" heading="Организации"/>
    <transition name="fade" mode="out-in">
      <router-view/>
    </transition>
  </div>
</template>

<script>
  export default {
    metaInfo: {title: 'Организации'},
    data: () => ({
      subnav: [
        {
          text: 'Поиск',
          to: '/billing/organizations/search',
          permission: 'web_billing_organizations',
        },
        {
          text: 'Тарифы',
          to: '/billing/organizations/tariffs',
          permission: 'web_billing_organizations',
        },
        {
          text: 'Список',
          to: '/billing/organizations/list',
          permission: 'web_billing_organizations',
        },
      ],
    }),
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/billing/organizations/index.vue